import {$controller} from "rapid/index";
import {clone, delay} from "lodash";

const dependencies = ["$Forms", "$companies", "$Booth", "$service", "$Deployment", "$Company"];

class AnalyticsController extends $controller {

    constructor($injector, $stateParams, $scope, $element, $auth, $window) {
        "ngInject";
        super($injector, dependencies);
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$element = $element;
        this.$auth = $auth;
        this.$window = $window;
        this.$scope.loading = true;
        this.$scope.query = {page: 1, search: ""};
        this.$scope.filter = {};
        this.$scope.deployments = [];
        this.$scope.pageCount = 0;
        this.$scope.canAddMore = true;
        this.$scope.logOrder = () => {
            this.$scope.query.ordering = this.$scope.query.order.replace("_", "");
            this.query(true);
        };
        this.logisticsType = {
            "by_upreach": "By UpReach",
            "by_client": "By Client"
        };

        this.searchByKeyPress = (event) => {
            const keyName = event.key;
            const letters = "abcdefghijklmnopqrstuvwxyz";
            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
                this.$scope.$apply(() => {
                    this.$scope.filter.show = true;
                    if (!this.$scope.query.search) {
                        this.$scope.query.search = keyName;
                    }
                });
                delay(() => {
                    document.getElementById("search-field").focus();
                }, 100);
            }
        };

    }

    $onInit() {
        this.$scope.filter.show = false;
        this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
        document.addEventListener("keypress", this.searchByKeyPress);
        //this.$scope.$watch("query.page", angular.bind(this, this.query));
        //this.query();
    }

    $onDestroy() {
        document.removeEventListener("keypress", this.searchByKeyPress);
    }

    query(isNew) {
        var deployments = this.$Deployment.query(this.$scope.query);

        Promise.all([deployments.$promise]).then(() => {
            this.$scope.query.page = deployments._meta.page || 1;
            this.$scope.loading = false;

            isNew ? this.$scope.deployments = deployments : this.$scope.deployments.push(...deployments);
            this.$scope.pageCount = deployments._meta.page_count;
            this.$scope.canAddMore = this.$scope.query.page !== this.$scope.pageCount;

            this.$scope.$apply();
        });
    }

    addMoreItems() {
        this.$scope.query.page++;
        this.query();
    }

    onQueryFilterChange() {
        this.$scope.query.page = 1;
        const newValue = clone(this.$scope.query.search);
        this.$scope.loading = true;
        this.searhDelayTimeout = setTimeout(() => {
            const prewValue = clone(this.$scope.query.search);
            if (prewValue === newValue) {
                clearTimeout(this.searhDelayTimeout);
                this.query(true);

            }
        }, 500);
    }

    removeFilter () {
        this.$scope.filter.show = false;
        this.$scope.query.search = "";
    }

    showFilter() {
        this.$scope.filter.show = true;
        delay(() => {
            document.getElementById("search-field").focus();
        }, 100);
    }

    onSearchBlur() {
        if (!this.$scope.query.search) {
            this.$scope.filter.show = false;
        }
    }

    isClient() {
        return this.$auth.isRole("Client") || this.$auth.isRole("Sub-User");
    }

    openInNewTab(id) {
        this.$window.open(this.$window.location.href + id, "_blank");
    }
}

export default AnalyticsController;



// WEBPACK FOOTER //
// ./sources/components/analytics/analytics.controller.js